import { FC } from 'react';
import ScanInput from '../ScanInput';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { getInputPlaceholder } from '../utils/ruleUtils';
import { ScanInputProps } from '../ScanInput/interface';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormScanInputProps extends BaseSearchFormItemProps {
  /** ScanInput Props */
  scanInputProps?: ScanInputProps;
}
/** 扫码输入框 */
export const SearchFormScanInput: FC<SearchFormScanInputProps> = props => {
  const {
    scanInputProps,
    render,
    disabledRender,
    isDetail,
    isTable,
    testId,
    rules,
    label,
    name,
    form,
    className,
    copy,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      name={name}
      {...resProps}
      disabled={isDetail || scanInputProps?.disabled}
      label={label}
      rules={rules}
      
    >
      {isDetail || (scanInputProps && scanInputProps.disabled) ? (
        <SearchFormDisabled
          form={form}
          name={name}
          render={render || disabledRender}
          company={resProps.company}
          isTable={isTable}
          copy={copy}
        />
      ) : (
        <ScanInput
          placeholder={getInputPlaceholder(label, scanInputProps, rules)}
          {...scanInputProps}
          test-id={`${testId}-${name}`}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormScanInput.displayName = SearchFormItemEnum.SearchFormScanInput;

export default SearchFormScanInput;
